import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import DisputeThread, { StatusBadge } from "./DisputeThread";
import { AlertTriangle, ChevronRight } from "lucide-react";

export default function MyDisputes({ refreshKey }) {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/my/disputes"); setItems(data); } catch { setItems([]); }
  };
  useEffect(() => { load(); }, [refreshKey]);

  if (items.length === 0) return null;

  return (
    <div data-testid="my-disputes-section">
      <h2 className="font-display text-xl font-bold mb-3 flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-amber-400" /> Your disputes</h2>
      <div className="space-y-2">
        {items.map((d) => (
          <button key={d.dispute_id} onClick={() => setActive(d)} data-testid={`my-dispute-${d.dispute_id}`}
            className="w-full text-left flex items-center justify-between p-4 rounded-xl bg-[#131722] border border-slate-800 hover:border-amber-500/40 transition-colors">
            <div className="min-w-0">
              <p className="font-semibold truncate">{d.car_label} <span className="text-slate-500 font-normal">· {d.kind.replace(/_/g, " ")}</span></p>
              <p className="text-xs text-slate-400 mt-0.5">{new Date(d.created_at).toLocaleDateString()} · {(d.events || []).length} update{(d.events || []).length === 1 ? "" : "s"}</p>
            </div>
            <div className="flex items-center gap-3 shrink-0"><StatusBadge status={d.status} /><ChevronRight className="w-4 h-4 text-slate-500" /></div>
          </button>
        ))}
      </div>
      <Dialog open={!!active} onOpenChange={(v) => !v && setActive(null)}>
        <DialogContent className="bg-[#131722] border-slate-800 max-w-lg" data-testid="my-dispute-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-white">Dispute · {active?.car_label}</DialogTitle>
            <DialogDescription className="text-xs text-slate-400">Status updates, replies and evidence for this ticket.</DialogDescription>
          </DialogHeader>
          {active && <DisputeThread dispute={active} onUpdated={(d) => { setActive(d); setItems((xs) => xs.map((x) => x.dispute_id === d.dispute_id ? d : x)); }} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
